var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { useCallback } from 'react';
import { apiGetListColumn } from '@/actions/ColumnActionsTs';
import { apiGetListDocument } from '@/actions/DocumentActionsTs';
import { useColumnListFilterSearch } from '@/container/Column/Common/UseCase/ColumnListSearchUseCase';
import { wrapDispatch } from '@/utils/actions/dispatch';
import { parseDocumentListData, parseColumnListData, } from '@/utils/resources/article/parseArticleListData';
/**
 * コラム検索処理
 * @param locationStateKey
 * @param dispatch
 * @param unmountRef
 * @param types
 * @returns {*}
 */
const useColumnListFilter = (locationStateKey, dispatch, unmountRef, types) => {
    /**
     * コラム一覧データ取得
     */
    const fetchColumnList = useCallback((params, page) => __awaiter(void 0, void 0, void 0, function* () {
        const action = apiGetListColumn({
            query: {
                column_themes: params.theme,
                page: page || 1,
            },
        });
        // 一覧データ 取得
        const response = yield wrapDispatch(dispatch, action);
        // 共通フォーマットに整形して返す
        return parseColumnListData(response.payload);
    }), [dispatch]);
    /**
     * ダウンロード資料一覧データ取得
     */
    const fetchDocumentList = useCallback((params, page) => __awaiter(void 0, void 0, void 0, function* () {
        const action = apiGetListDocument({
            query: {
                page: page || 1,
                themes: params.theme,
            },
        });
        // 一覧データ取得
        const response = yield wrapDispatch(dispatch, action);
        // 共通フォーマットに整形して返す
        return parseDocumentListData(response.payload);
    }), [dispatch]);
    /**
     * 一覧データ取得
     * @description ダウンロード資料の場合はfetchDocumentListを、コラムの場合はfetchColumnListを呼び出す
     */
    const searchColumns = useCallback((params, page) => __awaiter(void 0, void 0, void 0, function* () {
        return types === 'document'
            ? fetchDocumentList(params, page)
            : fetchColumnList(params, page);
    }), [fetchDocumentList, fetchColumnList, types]);
    const { getReplaceUrl, loadApi: loadColumns, loading, onChangeTypeFilter, onClickTheme, onLoadMoreApi: onLoadMoreColumns, paging, resetState, } = useColumnListFilterSearch(locationStateKey, searchColumns, unmountRef, types);
    return {
        getReplaceUrl,
        loadColumns,
        loading,
        onChangeTypeFilter,
        onClickTheme,
        onLoadMoreColumns,
        paging,
        resetState,
    };
};
export default {
    useColumnListFilter,
};
